import * as stylex from '@stylexjs/stylex';
import { MdTranslate } from 'react-icons/md';
import { LabeledSection } from '~pages/Profile/components/LabeledSection';
import { styles } from './styles';
import type { PublicLanguage } from '~pages/Profile/query';
export function Languages({
  languages
}: {
  languages: PublicLanguage[];
}) {
  if (languages.length === 0) return null;
  return <LabeledSection label="Languages" icon={<MdTranslate size={18} {...stylex.props(styles.icon)} />}>
      <div {...stylex.props(styles.chips)}>
        {languages.map(language => <span key={language.code} {...stylex.props(styles.chip)}>
            {language.nativeName}
          </span>)}
      </div>
    </LabeledSection>;
}